var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bread_container"},[_c('a',{staticClass:"reload",on:{"click":function($event){return _vm.reloads()}}},[_c('i',{staticClass:"el-icon-refresh"}),_vm._v("刷新")])])}
var staticRenderFns = []

export { render, staticRenderFns }